/** zh-CN 资源（一期唯一语言，REQ-UI-012）。key 约定 `<area>.<term>[.<value>]`（glossary）。 */
export const zhCN = {
  app: { name: '衔枝', tagline: '日衔寸枝，岁成一巢' },
  ui: {
    page: {
      today: '今日',
      tasks: '任务',
      inbox: '收件箱',
      entries: '记录',
      search: '搜索',
      notifications: '通知',
      settings: '设置',
      design: '设计画廊',
      trash: '回收站',
      calendar: '日历',
      spaces: '空间',
    },
    theme: {
      light: '日场',
      dark: '夜场',
      system: '跟随系统',
      toggle: '切换明暗',
      mode: '明暗模式',
    },
    // ADR-0059 · 0060 主题（代码里叫 skin；日场 / 夜场叫「明暗模式」）
    skin: {
      label: '主题',
      none: '衔枝原生',
      noneHint: '日场 / 夜场 · 玻璃强度',
      default: '默认',
      exit: '退出主题',
      setDefault: '设为默认',
      restoreDefault: '恢复默认主题',
      art: '图片强度',
      artNeedsTheme: '（选了主题后生效）',
      artLevel: { soft: '淡', medium: '中', strong: '浓' },
      locked: '（随主题）',
      empty: '还没有安装主题。运维在服务器上执行',
      missing: '你选的主题「{{id}}」已被卸载，暂按衔枝原生显示',
      missingName: '{{id}}（已卸载）',
    },
    action: {
      save: '保存',
      cancel: '取消',
      confirm: '确认',
      close: '关闭',
      delete: '删除',
      retry: '重试',
      copy: '复制',
      copied: '已复制',
      signOut: '退出登录',
      back: '返回',
      open: '打开',
      more: '更多',
    },
    nav: {
      collapseSidebar: '折叠侧栏',
      resizeSidebar: '调整侧栏宽度',
      resizeSidebarHint: '拖动调整宽度 · 双击还原',
      expandSidebar: '展开侧栏',
      collapseAside: '折叠侧边面板',
      openMenu: '打开菜单',
      me: '我',
      spaces: '空间',
      views: '我的视图',
      mainNav: '主导航',
      breadcrumb: '面包屑',
    },
    statusPill: {
      synced: '已同步',
      connecting: '连接中',
      offline: '本地已保存，联网后同步',
      readOnly: '只读',
      idle: '就绪',
    },
    palette: {
      blue: '蓝',
      orange: '橙',
      yellow: '黄',
      red: '红',
      green: '绿',
      purple: '紫',
      pink: '粉',
      cyan: '青',
      gray: '灰',
    },
    search: { placeholder: '搜索或输入命令' },
    loading: '加载中',
    notFound: {
      title: '找不到这个页面',
      body: '它可能已被删除，或者你没有访问权限。',
      home: '回到今日',
    },
    empty: {
      today: '今天还没有要衔的枝，去收件箱挑一根？',
      todayHint: '在下面直接写一个任务，回车就建好。',
      inbox: '收件箱是空的',
      inboxHint: '想到什么先丢进来，稍后再整理。',
      board: '这里还没有衔来的枝',
      boardHint: '在下面写下第一个任务。',
      entries: '还没有记录',
      entriesHint: '决定、迭代、踩坑、随笔……写下来就不会忘。',
      search: '没有找到匹配的内容',
      searchHint: '换个关键词，或者去掉筛选试试。',
      trash: '回收站是空的',
      notifications: '没有新通知',
      newTaskPlaceholder: '新任务，回车创建',
    },
    density: { label: '密度', comfortable: '舒适', compact: '紧凑', toggle: '切换列表密度' },
    savedJustNow: '已保存 · 刚刚',
  },
  glance: {
    schedule: '今日日程',
    openCalendar: '日历',
    noSchedule: '今天没有日程，去添加',
    dueSoon: '7 天内到期',
    noDue: '近期没有到期任务',
  },
  calendar: {
    today: '今天',
    prev: '上一段',
    next: '下一段',
    prevMonth: '上个月',
    nextMonth: '下个月',
    day: '日',
    month: '月',
    week: '周',
    year: '年',
    viewLabel: '日历视图',
    toggleSidebar: '显示 / 隐藏日历列表',
    allDay: '全天',
    due: '截止',
    start: '开始',
    end: '结束',
    more: '还有 {{count}} 项',
    moreInSlot: '同一时段还有 {{count}} 项，查看当天',
    monthDay: '{{m}}月{{d}}日',
    monthName: '{{m}}月',
    yearName: '{{y}}年',
    openWeek: '查看 {{date}} 所在的一周',
    openDay: '查看 {{date}}',
    eventLabel: '{{title}}（{{time}} · {{kind}}）',
    eventKind: '日程',
    taskKind: '任务',
    loading: '加载中…',
    newEvent: '新建日程',
    editEvent: '编辑日程',
    title: '标题',
    titlePlaceholder: '新日程',
    untitled: '新日程',
    calendar: '日历',
    time: '时间',
    startDate: '开始日期',
    startTime: '开始时间',
    endDate: '结束日期',
    endTime: '结束时间',
    location: '地点',
    locationPlaceholder: '添加地点',
    url: '链接',
    notes: '备注',
    notesPlaceholder: '添加备注',
    add: '添加',
    save: '保存',
    delete: '删除',
    created: '日程已添加',
    saved: '日程已保存',
    deleted: '日程已删除',
    moved: '日程已改期',
    stale: '日程已在别处被修改，已刷新，请重试',
    endBeforeStart: '结束时间须晚于开始时间',
    quick: {
      more: '更多选项…',
      close: '完成',
      details: '详情',
      date: '日期',
      time: '时间（留空 = 全天）',
      allDayHint: '全天任务：时间留空；填时间即定时',
      recurringHint: '重复日程：保存时会询问修改范围',
      markDone: '标记为完成',
      markUndone: '标记为未完成',
      taskDeleted: '已删除任务「{{title}}」',
      taskMoved: '任务已改期',
    },
    off: '休',
    work: '班',
    holidayOff: '{{name}} · 放假',
    holidayWork: '{{name}} · 调休上班',
    leap: '闰{{m}}',
    myCalendars: '我的日历',
    newCalendar: '新建日历',
    calendarName: '日历名称',
    editCalendar: '编辑日历「{{name}}」',
    color: '颜色',
    deleteCalendar: {
      title: '删除日历？',
      body: '「{{name}}」及其中的全部日程将被删除，且无法恢复。',
    },
    overlay: '同时显示',
    overlays: { tasks: '任务（截止 / 计划）', holidays: '法定节假日与调休', lunar: '农历与节气' },
    upcoming: '接下来',
    lunarLine: '农历{{date}} · {{year}}',
    dayEmpty: '这一天没有日程，点左侧时间轴即可添加',
    noUpcoming: '未来 7 天没有日程',
    wd: { 0: '日', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六' },
    repeat: {
      label: '重复',
      none: '不重复',
      everyDay: '每 {{count}} 天',
      everyDayOne: '每天',
      weekdays: '每个工作日',
      everyWeek: '每 {{count}} 周',
      everyWeekOne: '每周',
      everyMonth: '每 {{count}} 个月',
      everyMonthOne: '每月',
      everyYear: '每 {{count}} 年',
      everyYearOne: '每年',
      onDays: '（周{{days}}）',
      sep: '、',
      until: '，至 {{date}}',
      times: '，共 {{count}} 次',
      every: '每',
      interval: '间隔',
      freq: '频率',
      onWeekdays: '重复的星期',
      unit: { DAILY: '天', WEEKLY: '周', MONTHLY: '个月', YEARLY: '年' },
      endLabel: '结束',
      endNever: '永不',
      endUntil: '于日期',
      endCount: '重复次数',
      preset: {
        none: '不重复',
        daily: '每天',
        weekdays: '每个工作日',
        weekly: '每周',
        biweekly: '每两周',
        monthly: '每月',
        yearly: '每年',
        custom: '自定义…',
      },
    },
    alarm: {
      label: '提醒',
      add: '添加提醒',
      remove: '移除提醒',
      atTime: '事件发生时',
      minutes: '{{count}} 分钟前',
      hours: '{{count}} 小时前',
      days: '{{count}} 天前',
      after: '开始后 {{count}} 分钟',
      dayOf: '当天（09:00）',
      dayBefore: '{{count}} 天前（09:00）',
      weekBefore: '1 周前（09:00）',
    },
    scope: {
      saveTitle: '这是一个重复日程',
      saveBody: '要只更改这一次，还是同时更改将来的所有日程？',
      deleteTitle: '删除重复日程',
      deleteBody: '要只删除这一次，还是同时删除将来的所有日程？',
      this: '仅此日程',
      future: '将来所有日程',
      all: '所有日程',
    },
  },
  auth: {
    signIn: '登录',
    email: '邮箱',
    identifier: '邮箱或用户名',
    password: '密码',
    submit: '登录',
    passkey: '使用通行密钥登录',
    magicLink: '发送登录链接',
    magicLinkSent: '如果该邮箱已加入工作区，登录链接已发送。',
    invalid: '账号或密码不正确',
    pending: '注册申请正在等待管理员审批，通过后即可登录',
    magicLinkNeedsEmail: '登录链接需要填写邮箱',
    noAccount: '还没有账号？',
    register: {
      link: '申请注册',
      title: '申请注册',
      intro: '提交后由管理员审批，通过即可登录',
      username: '用户名',
      usernameRule: '3–30 位字母、数字或 _ . -，以字母或数字开头，可用于登录',
      name: '显示名',
      password: '设置密码（至少 {{n}} 位）',
      passwordRule: '密码至少 {{n}} 位',
      emailInvalid: '请输入有效的邮箱',
      nameRequired: '请填写显示名',
      submit: '提交申请',
      busy: '申请过于频繁，请稍后再试',
      failed: '提交失败，请稍后重试',
      doneTitle: '申请已提交',
      doneBody: '管理员审批通过后，你就可以用邮箱或用户名登录了。',
      backToLogin: '返回登录',
      haveAccount: '已有账号？',
    },
    rateLimited: '尝试过于频繁，请在 {{seconds}} 秒后重试',
    locked: '连续失败次数过多，账号已锁定 15 分钟',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    or: '或',
    captcha: {
      label: '拼图滑块',
      drag: '向右拖动滑块，完成拼图',
      solved: '拼图完成',
      refresh: '换一张',
      failed: '滑块验证未通过，请重新拼一次',
      required: '请先完成拼图',
      loadFailed: '拼图加载失败，点此重试',
    },
    /** ADR-0034 认证页小燕的气泡（装饰，aria-hidden） */
    bird: {
      hello: {
        login: '啾～今天也来衔一根枝吧',
        register: '新燕来啦？先报个名～',
        twoFactor: '再对一下暗号就好',
        invite: '有人邀你一起筑巢～',
      },
      scout: '我帮你看着～',
      scoutName: '嗯？是「{{name}}」吗',
      cover: '我不看，我不看！',
      peek: '就……偷看一眼',
      captcha: '对准缺口，拼上它～',
      error: '咦？好像哪里不对…',
      success: '衔到啦，回巢～',
      sleep: '呼……Zzz',
      shy: '别、别戳啦…',
      love: '啾啾，最喜欢你了',
      chirp: '啾啾～',
      foot: '一枝一叶，岁成一巢',
    },
    twoFactor: {
      title: '两步验证',
      code: '验证码',
      useBackup: '改用恢复码',
      backupCode: '恢复码',
      verify: '验证',
      invalid: '验证码不正确',
    },
    invitation: {
      title: '加入工作区',
      intro: '{{inviter}} 邀请你以「{{role}}」身份加入 {{workspace}}',
      name: '显示名',
      password: '设置密码（至少 8 位）',
      emailHint: '请输入收到邀请的邮箱（{{masked}}）',
      accept: '接受邀请',
      expired: '邀请已过期或已被撤回，请联系管理员',
      used: '邀请已使用，请直接登录',
      mismatch: '邮箱与邀请不一致',
      notFound: '邀请不存在',
      goLogin: '去登录',
    },
    role: { owner: '所有者', admin: '管理员', member: '成员', guest: '访客' },
  },
  settings: {
    nav: {
      profile: '个人',
      theme: '主题',
      notifications: '通知',
      security: '安全',
      apiKeys: 'API Key',
      templates: '模板',
      reading: '阅读与写作',
      workspaceGroup: '工作区',
      workspace: '工作区信息',
      members: '成员',
      users: '用户管理',
      audit: '审计日志',
      design: '设计画廊',
      tags: '标签',
      types: '类型',
    },
    types: {
      title: '类型',
      hint: '内置类型全工作区统一，由所有者维护；自定义类型是你自己的，可设颜色与状态，只有你能用它新建记录，别人查看你的记录时能看到类型名与状态',
      custom: '我的自定义类型',
      fieldsAndColors: '字段与状态颜色',
      statusColors: '状态颜色',
      statusColor: '「{{status}}」的颜色',
      extraFields: '追加字段（{{count}}）',
      fields: '字段（{{count}}）',
      spaceTypesNote: '空间类型在各空间的「类型与字段」里管理（你可见 {{count}} 个）。',
      builtin: '内置类型',
      builtinHint:
        '内置类型带固定属性与正文模板，由所有者改名、改色、调整字段（隐藏 / 改名 / 排序）或删除（删除后可恢复）',
      deletedBuiltin: '已删除的内置类型',
      restore: '恢复',
      restored: '已恢复类型',
      resetDefault: '恢复默认名称与颜色',
      moveTo: '其下记录转为',
      name: '类型名',
      namePlaceholder: '新类型名，如「读书笔记」',
      statuses: '状态',
      statusesPlaceholder: '状态（可选），用空格或逗号分隔，如：想读 在读 读完',
      new: '新建类型',
      empty: '还没有自定义类型',
      created: '已新建类型',
      saved: '已保存类型',
      deleted: '已删除类型',
      delete: '删除类型',
      deleteTitle: '删除类型「{{name}}」？',
      deleteBody:
        '其下 {{count}} 篇记录（含回收站）会转到下面选择的类型，仍合法的状态与进度保留，其余属性清空。',
      usage: '{{count}} 篇记录',
      noStatuses: '不使用状态',
      moveLeft: '把「{{name}}」前移',
      statusName: '第 {{n}} 个状态',
      removeStatus: '移除状态「{{name}}」',
      addStatus: '+ 添加状态',
      saveStatuses: '保存状态',
      reset: '还原',
      statusesHint:
        '改名会同步到已有记录；被移除状态的记录改为第一个状态；第一个状态是新建记录的默认值',
    },
    tags: {
      title: '标签',
      hint: '标签是你自己的：只有你看得到、用得了；你打在共享记录上的标签，别人看不到',
      empty: '还没有标签：在记录或任务的标签选择器里输入即可新建',
      usage: '{{entries}} 篇记录 · {{tasks}} 个任务',
      name: '名称',
      color: '颜色',
      merge: '合并到…',
      mergeTitle: '把「{{from}}」合并到「{{to}}」？',
      mergeBody: '使用「{{from}}」的记录和任务都会改用「{{to}}」，然后删除「{{from}}」。',
      merged: '已合并到「{{name}}」',
      delete: '删除',
      deleteTitle: '删除标签「{{name}}」？',
      deleteBody: '会从所有记录和任务上移除该标签，此操作不可撤销。',
      deleted: '已删除标签',
      saved: '已保存',
      readonly: '只有管理员或创建者可修改',
      viewEntries: '查看记录',
      search: '筛选标签…',
      new: '新建标签',
      newPlaceholder: '标签名，回车创建',
    },
    // ADR-0060 设置 → 主题
    theme: {
      title: '主题',
      hint: '主题、明暗模式与界面偏好随账号保存，在所有设备生效',
      appearance: '明暗与界面',
      workspaceHint:
        '成员没单独选过的项跟随这里；默认主题在上方卡片上「设为默认」，登录 / 注册页也用它',
      defaultSaved: '已设为工作区默认',
    },
    profile: {
      email: '邮箱',
      displayName: '显示名',
      timezone: '时区',
      weekStartsOn: '每周从哪天开始',
      locale: '语言',
      density: '列表密度',
      comfortable: '舒适',
      compact: '紧凑',
      motion: '动效',
      motionLevel: { standard: '标准', rich: '丰富', reduce: '减弱' },
      glass: '玻璃强度',
      glassLevel: { liquid: '流光', vivid: '晶亮', clear: '清透', standard: '标准' },
      localHint: '外观随账号保存，在所有设备生效；没单独选过的项跟随工作区默认',
      appearanceDefault: '{{name}}（默认）',
      appearanceReset: '恢复为工作区默认',
      appearanceSaveFailed: '外观偏好没保存上，刷新后会回到之前的设置',
      zhCN: '简体中文',
      avatar: '头像',
      avatarUpload: '上传头像',
      avatarChange: '更换',
      avatarRemove: '移除',
      avatarHint: 'PNG / JPG / WebP / GIF / SVG，自动裁成正方形',
      avatarUpdated: '头像已更新',
      avatarRemoved: '头像已移除',
      avatarFailed: '头像上传失败',
      account: '账号',
      username: '用户名',
      usernameHint: '可用于登录；3–30 位字母、数字或 _ . -，以字母或数字开头',
      usernameEmpty: '未设置',
      usernameChanged: '用户名已修改',
      changeEmail: '修改邮箱',
      newEmail: '新邮箱',
      currentPassword: '当前密码',
      emailChanged: '邮箱已修改',
      save: '保存',
      edit: '修改',
    },
    keys: {
      hint: '用于脚本与集成（MCP 属二期）。Key 的权限不会超过你的角色；每个 Key 每分钟最多 300 次请求。',
      name: '名称',
      scope: '权限',
      expires: '过期日期（可选）',
      create: '新建 Key',
      empty: '还没有 API Key',
      scopes: { read: '只读', write: '读写', admin: '管理' },
      lastUsed: '最近使用',
      neverUsed: '从未使用',
      expiresAt: '{{date}} 过期',
      revoke: '撤销',
      revokeTitle: '撤销这个 Key？',
      revokeHint: '「{{name}}」撤销后立即失效，使用它的脚本会收到 401。',
      revoked: '已撤销',
      createdTitle: 'Key 已创建',
      onceHint: '明文只显示这一次，请立即复制保存；关闭后无法再次查看。',
      saved: '我已保存',
    },
    workspace: {
      name: '名称',
      slug: '标识（slug）',
      appearance: '默认外观',
      logoLater: 'Logo 设置将在后续版本提供。',
    },
    members: {
      tab: { members: '成员', requests: '待审批', invitations: '邀请' },
      requestedAt: '申请于',
      approve: '批准',
      approved: '已批准 {{name}} 加入',
      reject: '驳回',
      rejected: '已驳回，申请账号已删除',
      noRequests: '没有待审批的注册申请',
      inviteEmail: '邀请邮箱',
      role: '角色',
      roles: { owner: '所有者', admin: '管理员', member: '成员', guest: '访客' },
      invite: '发送邀请',
      invited: '已邀请 {{email}}',
      suspended: '已停用',
      suspend: '停用',
      unsuspend: '恢复',
      unsuspended: '已恢复，对方需重新登录',
      suspendedToast: '已停用，对方已被登出',
      remove: '移除',
      removed: '已移除',
      transfer: '转让所有权',
      transferred: '所有权已转让',
      roleChanged: '角色已更新',
      lastOwner: '至少要保留一名所有者',
      expires: '过期',
      revokeInvite: '撤销邀请',
      inviteRevoked: '邀请已撤销',
      noInvites: '没有待处理的邀请',
      inviteStatus: {
        pending: '待接受',
        accepted: '已接受',
        canceled: '已撤销',
        expired: '已过期',
      },
      confirm: {
        remove: {
          title: '移除成员？',
          body: '「{{name}}」将立即被登出；内容保留，未完成任务的指派会被清空。',
        },
        suspend: { title: '停用成员？', body: '「{{name}}」将立即被登出且无法登录，可随时恢复。' },
        transfer: { title: '转让所有权？', body: '「{{name}}」将成为所有者，你会变为管理员。' },
        reject: { title: '驳回注册申请？', body: '将删除「{{name}}」的申请账号，对方可重新申请。' },
      },
    },
    audit: {
      time: '时间',
      actor: '操作人',
      action: '动作',
      target: '对象',
      allActors: '全部操作人',
      empty: '还没有记录',
      system: '系统',
      unknownActor: '已离开的成员',
    },
    security: {
      title: '安全',
      twoFactor: '两步验证（TOTP）',
      twoFactorOn: '已开启',
      twoFactorOff: '未开启',
      enable: '开启两步验证',
      disable: '关闭两步验证',
      confirmPassword: '输入当前密码以确认',
      scanHint: '用验证器 App 扫描下方链接，或手动输入密钥，然后填写 6 位验证码。',
      verify: '验证并开启',
      backupCodes: '恢复码（每个只能用一次，请离线保存）',
      backupSaved: '我已保存恢复码',
      passkeys: '通行密钥',
      addPasskey: '添加通行密钥',
      noPasskeys: '还没有通行密钥',
      sessions: '登录会话',
      current: '当前',
      revoke: '注销',
      unknownDevice: '未知设备',
      password: '登录密码',
      passwordHint: '修改后其他设备上的登录会话会被退出，当前设备保持登录。',
      currentPassword: '当前密码',
      newPassword: '新密码（至少 {{n}} 位）',
      confirmNewPassword: '再次输入新密码',
      passwordMismatch: '两次输入的新密码不一致',
      passwordTooShort: '新密码至少 {{n}} 位',
      changePassword: '修改密码',
      passwordChanged: '密码已修改，已退出其他 {{count}} 个会话',
    },
    users: {
      title: '用户管理',
      hint: '仅所有者可见：直接创建账号、修改资料、重置密码、强制下线或删除账号。角色、停用与注册审批在「成员」页。',
      create: '新建用户',
      createTitle: '新建用户',
      createHint: '创建后立即成为工作区成员，可用邮箱或用户名 + 初始密码登录。',
      email: '邮箱',
      username: '用户名',
      name: '显示名',
      password: '初始密码（至少 {{n}} 位）',
      role: '角色',
      generate: '随机生成',
      created: '已创建 {{name}}',
      edit: '编辑资料',
      editTitle: '编辑「{{name}}」',
      saved: '资料已保存',
      resetPassword: '重置密码',
      resetTitle: '重置「{{name}}」的密码',
      resetHint: '新密码立即生效，该用户所有设备会被强制退出。请把新密码告知对方。',
      newPassword: '新密码（至少 {{n}} 位）',
      resetDone: '密码已重置，已退出 {{count}} 个会话',
      signOut: '强制下线',
      signedOut: '已强制下线 {{count}} 个会话',
      delete: '删除账号',
      deleted: '账号已删除',
      you: '你',
      lastActive: '最近活跃',
      never: '无会话',
      sessions: '{{count}} 个会话',
      twoFactor: '已开 2FA',
      noUsername: '无用户名',
      actions: '操作',
      confirm: {
        signOut: {
          title: '强制下线？',
          body: '「{{name}}」所有设备上的登录会立即失效，需要重新登录。',
        },
        delete: {
          title: '删除账号？',
          body: '「{{name}}」的账号将被匿名化且无法恢复：不能再登录，邮箱与用户名被释放；创建的内容保留。',
        },
      },
    },
  },
  task: {
    task: '任务',
    newTask: '新任务',
    newTaskPlaceholder: '写下任务，回车创建',
    created: '已创建任务',
    status: {
      inbox: '收件箱',
      todo: '待办',
      doing: '进行中',
      blocked: '阻塞',
      done: '完成',
      cancelled: '取消',
    },
    priority: { 0: '无', 1: '低', 2: '中', 3: '高', 4: '紧急' },
    priorityLabel: '优先级',
    statusLabel: '状态',
    assignee: '指派给',
    unassigned: '未指派',
    dueAt: '截止',
    scheduledAt: '计划',
    estimate: '预估（分钟）',
    tags: '标签',
    description: '描述',
    descriptionPlaceholder: '补充说明…（可粘贴 / 拖入图片）',
    insertImage: '插入图片',
    hasDescription: '有详情',
    subtask: '子任务',
    addSubtask: '添加子任务',
    watcher: '关注',
    watchers: '关注者',
    follow: '关注',
    unfollow: '取消关注',
    column: '列',
    completed: '已完成「{{title}}」',
    undo: '撤销',
    undone: '已撤销完成',
    rescheduled: '已改期到明天',
    conflict: '任务已被他人修改，已刷新为最新内容',
    saveFailed: '保存失败，已恢复',
    savedJustNow: '已保存 · 刚刚',
    notFound: '任务不存在或不可见',
    moveFailed: '移动没有保存，已放回原处',
    selected: '已选 {{count}} 项',
    batchStatus: '改状态',
    batchAssign: '指派',
    batchDelete: '删除',
    batchDone: '已更新 {{count}} 个任务',
    clearSelection: '取消选择',
    view: { board: '看板', list: '列表' },
    tasks: '任务',
    filter: {
      mine: '指派给我',
      today: '今天到期',
      week: '本周到期',
      overdue: '已逾期',
      all: '全部',
      search: '筛选标题…',
    },
    showDone: '显示已完成',
    hideDone: '收起已完成',
    section: {
      overdue: '逾期',
      dueToday: '今日到期',
      scheduledToday: '今日开始',
      done: '今天完成的',
    },
    /** 今日页题记下的摘要（04 §3 页头） */
    stat: {
      overdue: '逾期',
      dueToday: '今日到期',
      scheduledToday: '今日开始',
      events: '今日日程',
    },
    summary: {
      overdue: '{{count}} 项逾期',
      dueToday: '{{count}} 项今日到期',
      scheduledToday: '{{count}} 项今日开始',
      inbox: '先收下，再分拣：挑进空间，或定下状态',
    },
    moveToSpace: '移到空间',
    loadMore: '加载更多',
    keyboardHint: 'j / k 移动 · 空格完成 · r 改名 · m 菜单 · x 多选（Shift+J / K 扩选）· 回车打开',
    open: '打开',
    close: '关闭',
    deleted: '已删除任务',
    tagCreate: '创建标签「{{name}}」',
    tagSearch: '搜索或新建标签',
    tagColor: '新标签颜色',
  },
  /** 任务页（ADR-0043） */
  tasksPage: {
    space: '按空间筛选',
    allSpaces: '全部空间',
    groupBy: '分组方式',
    groupMode: { date: '按日期分组', priority: '按优先级分组', list: '按清单分组', none: '不分组' },
    add: '添加',
    emptyHint: '在上面一句话写下，回车即建：如「明天 买牛奶 !高 #生活 ~购物」',
    empty: {
      all: '没有未完成的任务，今天可以歇歇',
      today: '今天没有要做的事',
      tomorrow: '明天还空着',
      next7: '接下来一周没有安排',
      unlisted: '所有任务都已归进清单',
      done: '还没有完成的任务',
      list: '这个清单还是空的',
      folder: '这个文件夹里的清单都还是空的',
      tag: '这个标签下没有未完成的任务',
    },
    group: {
      overdue: '已逾期',
      today: '今天',
      tomorrow: '明天',
      week: '未来 7 天',
      later: '以后',
      noDate: '无日期',
      all: '全部',
      unlisted: '未归类',
    },
  },
  /** 个人清单（ADR-0044） */
  taskLists: {
    nav: '任务清单',
    lists: '清单',
    list: '清单',
    unlisted: '未归类',
    smart: {
      all: '全部',
      today: '今天',
      tomorrow: '明天',
      next7: '最近 7 天',
      unlisted: '未归类',
      done: '已完成',
    },
    overdueHint: '其中 {{n}} 项已逾期',
    tagsMore: '全部 {{n}}',
    tagsLess: '收起',
    new: '新建清单',
    newFolder: '新建文件夹',
    folder: '文件夹',
    toggleFolder: '展开 / 收起「{{name}}」',
    newPlaceholder: '清单名，如 生活',
    newFolderPlaceholder: '文件夹名，如 工作',
    empty: '还没有清单，点右上角 + 新建',
    menu: '「{{name}}」的更多操作',
    color: '清单颜色',
    rename: '名称',
    moveTo: '移到文件夹',
    moveToRoot: '移出文件夹',
    delete: '删除清单',
    deleteFolder: '删除文件夹',
    deleteTitle: '删除清单「{{name}}」？',
    deleteFolderTitle: '删除文件夹「{{name}}」？',
    deleteBody: '清单里的任务不会被删除，会回到「未归类」。',
    deleteFolderBody: '文件夹里的清单会移到最外层，任务不受影响。',
    deleteConfirm: '删除',
  },
  /** 右侧详情坞（ADR-0054 §B） */
  dock: {
    resize: '拖动调整详情栏宽度',
    openFull: '打开完整页面',
    close: '关闭详情',
    notFound: '记录不存在或无权查看',
  },
  /** 任务行内编辑（ADR-0045） */
  taskRow: {
    due: '日期',
    addDue: '设置日期',
    list: '清单',
    addList: '归入清单',
    tags: '标签',
    addTags: '添加标签',
    menu: '更多操作',
    open: '打开详情',
    select: '选择：{{title}}',
    rename: '任务标题',
  },
  /** 任务单个管理菜单（ADR-0045） */
  taskMenu: {
    complete: '完成',
    uncomplete: '取消完成',
    open: '打开详情',
    due: '日期',
    pickDate: '自选…',
    moveToList: '移到清单…',
    moveToSpace: '移到空间',
    movedToSpace: '已移到「{{name}}」',
    copyTitle: '复制标题',
    copyFailed: '复制失败',
    delete: '删除',
  },
  /** 任务批量（ADR-0045） */
  taskBatch: {
    toolbar: '批量操作',
    select: '选择',
    exitSelect: '完成选择',
    selectAll: '全选',
    done: '已更新 {{n}} 个任务的{{what}}',
    completed: '已完成 {{n}} 个任务',
    deleted: '已删除 {{n}} 个任务',
    undone: '已撤销',
    undoSkipped: '（其中 {{n}} 个不是你建的，不能撤销）',
    partial: '已处理 {{ok}} / {{total}}；未完成：{{reason}}',
    failedItem: '「{{title}}」{{reason}}',
    tagsHint: '点一下：全都有则移除，否则全部加上',
    what: {
      due: '日期',
      priority: '优先级',
      list: '清单',
      space: '空间',
      tags: '标签',
      status: '状态',
    },
  },
  /** 任务拖放（ADR-0044） */
  taskDnd: {
    toList: '已移到清单「{{name}}」',
    unlisted: '已移出清单',
    today: '已改到今天',
    tomorrow: '已改到明天',
    noDate: '已清除截止日期',
    priority: '优先级改为「{{p}}」',
    dropHere: '松手放到这里',
    instructions: '用鼠标拖到左侧清单、今天 / 明天，或别的分组；也可以在详情里改清单与日期',
  },
  /** 任务日期选择（ADR-0044） */
  picker: {
    due: {
      today: '今天',
      tomorrow: '明天',
      nextMonday: '下周一',
      none: '无日期',
      presets: '相对日期快选',
      in1w: '1 周后',
      in2w: '2 周后',
      in1m: '1 个月后',
      in6m: '半年后',
      in1y: '1 年后',
      prevMonth: '上个月',
      nextMonth: '下个月',
      time: '时间',
    },
  },
  /** 快速添加（ADR-0043 · 0044） */
  quickAdd: {
    label: '快速添加任务',
    placeholder: '添加任务，回车创建；Shift+回车 展开写备注和子任务',
    compactPlaceholder: '添加到这一组，回车创建',
    hint: '可识别：今天 / 明天 / 周五 / 10月8日 / 下午3点 · !紧急 !高 !中 !低 · #标签 · ~清单',
    ignore: '不识别「{{text}}」',
    noList: '没有清单或空间「{{name}}」',
    due: '日期',
    priority: '优先级',
    list: '清单',
    tags: '标签',
    expand: '展开：备注与子任务',
    collapse: '收起',
    note: '备注',
    notePlaceholder: '备注（可选）',
    subtaskPlaceholder: '子任务，回车再加一条',
    submitHint: 'Ctrl / ⌘ + 回车 创建',
    submit: '创建',
  },
  space: {
    space: '空间',
    parts: '空间',
    newSpace: '新建空间',
    mine: '我的空间',
    others: '其他可见空间',
    archived: '已归档',
    personal: '个人',
    empty: '还没有空间，衔来第一根枝吧',
    emptyHint:
      '空间是记录与任务的容器：一个产品（如简斋、衔枝）、一门课、一件生活里的事都可以是一个空间；空间再按大类归组。',
    ungrouped: '未分类',
    group: '大类',
    groups: {
      manage: '管理大类',
      manageHint:
        '大类用来给空间归组（如产品开发 / 技术学习规划 / 生活）；删除大类不会删除空间，其下空间变为未分类。',
      add: '新建大类',
      name: '大类名称',
      rename: '重命名',
      delete: '删除大类',
      deleteConfirm: '删除大类「{{name}}」？其下空间会变为「未分类」。',
      moveUp: '上移',
      moveDown: '下移',
      newHere: '在此新建',
      count: '{{count}} 个空间',
      none: '不归类',
      menu: '大类「{{name}}」的操作',
      addHere: '在此大类新建空间',
      renamed: '已改名为「{{name}}」',
    },
    moveToGroup: '移到大类',
    newEntryIn: '在「{{name}}」新建记录',
    movedToGroup: '已把「{{name}}」移到「{{group}}」',
    archivedEmpty: '没有归档的空间',
    loadError: '空间加载失败',
    name: '名称',
    namePlaceholder: '例如：产品开发',
    slug: '短链接',
    slugHint: '只允许小写字母、数字与中划线；留空按名称生成',
    kindLabel: '类型',
    kind: { project: '项目', learning: '学习', work: '工作' },
    visibilityLabel: '可见性',
    visibility: { workspace: '全员可见', members: '仅成员' },
    color: '颜色',
    icon: '图标',
    noIcon: '默认',
    create: '创建',
    created: '已创建空间「{{name}}」',
    archive: '归档',
    unarchive: '取消归档',
    archivedToast: '已归档「{{name}}」',
    unarchivedToast: '已取消归档「{{name}}」',
    archivedBanner: '空间已归档，只读',
    members: '{{count}} 位成员',
    role: { admin: '空间管理员', member: '空间成员', viewer: '查看者' },
    dragHandle: '拖动「{{name}}」调整顺序',
    dragInstructions: '按空格键拿起，用上下方向键移动，再按空格键放下，按 Esc 取消。',
    dragPicked: '已拿起「{{name}}」',
    dragOver: '移动到「{{name}}」的位置',
    dragDropped: '已放下「{{name}}」',
    dragCanceled: '已取消移动',
    reorderFailed: '排序没有保存，已恢复原顺序',
    comingSoon: '这个空间的看板与列表视图即将上线。',
    actions: '空间操作',
    menu: {
      label: '「{{name}}」的操作',
      rename: '空间名称',
      renamed: '已改名为「{{name}}」',
      iconColor: '图标与颜色',
      edit: '编辑空间…',
      delete: '删除空间',
      deleteTitle: '删除空间「{{name}}」？',
      deleteBody:
        '空间里的 {{entries}} 条记录、{{tasks}} 个任务将一起移入回收站，{{days}} 天后彻底清除；可点「撤销」或在回收站恢复。',
      deleted: '已删除空间「{{name}}」',
      renameTitle: '点击改名',
      iconTitle: '更换图标与颜色',
    },
    batch: {
      enter: '批量管理',
      exit: '完成',
      bar: '空间批量操作',
      selected: '已选 {{count}} 个',
      selectAll: '全选',
      selectSection: '全选本组',
      clear: '取消选择',
      select: '选择「{{name}}」',
      archive: '归档',
      unarchive: '取消归档',
      moveTo: '移到大类',
      delete: '删除',
      result: '已处理 {{ok}} 个空间',
      partial: '成功 {{ok}} 个，{{failed}} 个未处理：{{reason}}',
      deleteTitle: '删除 {{count}} 个空间？',
      deleteBody:
        '其中共有 {{entries}} 条记录、{{tasks}} 个任务，将随空间一起移入回收站，{{days}} 天后彻底清除。',
      deleteSkipped: '另有 {{count}} 个你无权删除，将跳过。',
      deleted: '已删除 {{count}} 个空间',
      archived: '已归档 {{count}} 个空间',
      undo: '撤销',
      undone: '已撤销',
      hint: '个人空间与你不管理的空间不可选',
    },
    merge: {
      menu: '合并到…',
      title: '把「{{name}}」合并到…',
      hint: '全部记录、任务（含评论与附件）与成员并入目标空间，目录接在目标目录末尾；合并后本空间移入回收站，内容不会自动搬回。',
      pick: '目标空间',
      noTarget: '没有可合并到的空间：目标须是你管理的、未归档的非个人空间',
      summary: '将搬移 {{entries}} 条记录、{{tasks}} 个任务，{{members}} 位成员加入目标空间。',
      widened: '「{{from}}」仅成员可见，目标空间全员可见：合并后其内容将对整个工作区可见。',
      confirm: '合并',
      done: '已把「{{from}}」合并到「{{into}}」',
      open: '打开',
    },
  },
  /** 空间的类型与字段（ADR-0036） */
  spaceTypes: {
    menu: '类型与字段',
    title: '{{name}} · 类型与字段',
    hint: '勾选的类型出现在空间首页、新建菜单与筛选里；空间类型由本空间成员共用。',
    enabled: '已启用',
    available: '可启用',
    enable: '启用 {{name}}',
    resetDefault: '恢复默认',
    spaceType: '空间',
    personalType: '个人',
    new: '新建空间类型',
    newPlaceholder: '新类型，如 需求',
    defaultTodo: '待办',
    defaultDoing: '进行中',
    defaultDone: '完成',
    builtinNote:
      '内置类型的字段由系统定义，可隐藏、改显示名、调整顺序，也可追加字段（工作区统一，仅所有者可改）。',
    personalNote: '个人类型只有你能用，请在「设置 · 类型」里管理。',
    extraFields: '追加字段',
    statuses: '状态',
    statusName: '状态名',
    addStatus: '状态',
    saveStatuses: '保存状态',
    deleteTitle: '删除类型「{{name}}」？',
    deleteBody: '其下 {{count}} 条记录会转为随笔，绑定它的模板也会转为随笔。',
  },
  /** 内置字段覆盖（ADR-0042） */
  builtinFields: {
    title: '内置字段',
    hint: '隐藏的字段在各处（空间概览、列表、属性栏、筛选、看板、统计）都不再出现，记录里的值保留，重新显示即可找回。显示名留空 = 默认名。',
    show: '显示「{{name}}」',
    hide: '隐藏「{{name}}」',
    label: '「{{name}}」的显示名',
    optionLabel: '选项「{{name}}」的显示名',
    optionColor: '「{{name}}」的颜色',
    defaultOption: '默认值选项不能隐藏',
    requiredHidden: '隐藏后不再必填',
    extra: '追加字段',
    restore: '恢复默认字段',
  },
  /** 字段定义（ADR-0036） */
  fieldDefs: {
    title: '字段',
    empty: '还没有自定义字段',
    add: '添加字段',
    label: '字段名',
    labelPlaceholder: '字段名，如 阶段',
    type: '字段类型',
    typeLocked: '字段类型建好后不能改，请新建字段',
    required: '必填',
    up: '上移',
    down: '下移',
    remove: '删除字段',
    option: '选项',
    optionPlaceholder: '选项',
    optionColor: '选项颜色',
    addOption: '选项',
    removeOption: '删除选项',
    save: '保存字段',
    reset: '撤销',
    invalid: '字段名与选项不能为空',
    lossTitle: '会清空这些数据',
    lossBody: '删除后，记录与模板里这些字段 / 选项的值会被清空：{{items}}。',
    types: {
      text: '文本',
      number: '数字',
      date: '日期',
      select: '单选',
      multiselect: '多选',
      checkbox: '勾选',
      url: '链接',
      progress: '进度',
    },
  },
  /** 元数据就地编辑（ADR-0035） */
  field: {
    yes: '是',
    no: '否',
    clear: '清空',
    today: '今天',
    save: '保存',
    empty: '空',
    required: '必填',
    edit: '修改{{name}}',
    saved: '已保存',
    dateQuick: { yesterday: '昨天', today: '今天', tomorrow: '明天' },
    dateInvalid: '请输入完整日期，如 2026-10-09',
    dateRange: '日期须在 {{min}} ~ {{max}} 之间',
  },
  entry: {
    nav: {
      newChild: '在「{{name}}」下新建子页',
      label: '记录位置',
      all: '全部记录',
      recent: '最近打开',
      favorite: '收藏',
      archived: '已归档',
      personal: '个人随笔',
      ungrouped: '未分类',
      expand: '展开 {{name}}',
      collapse: '收起 {{name}}',
      treeEmpty: '目录为空',
      recentEmpty: '还没有打开过记录',
      favoriteEmpty: '还没有收藏：在记录的 ⋯ 菜单里点「收藏」',
      archivedEmpty: '没有已归档的记录',
      toggle: '选择位置',
    },
    menu: {
      label: '更多操作',
      favorite: '收藏',
      unfavorite: '取消收藏',
      newChild: '新建子页面',
      newLinked: '新建关联记录',
      exportMd: '导出 Markdown',
      exportHtml: '导出 HTML',
      exportFailed: '导出失败',
      archive: '归档',
      unarchive: '取消归档',
      archivedToast: '已归档「{{title}}」',
      unarchivedToast: '已取消归档',
      delete: '删除',
      deleteTitle: '删除这篇记录？',
      deleteBody: '记录会移到回收站，可在回收站或点「撤销」恢复；目录下的子页会一并移出目录。',
      deleted: '已删除「{{title}}」',
      undo: '撤销',
      restored: '已恢复',
      archivedBadge: '已归档',
      rename: '标题',
      renamed: '已改名为「{{title}}」',
      rowLabel: '「{{title}}」的操作',
      duplicate: '创建副本',
      copyTo: '复制到…',
      moveTo: '移动到…',
      duplicated: '已创建副本「{{title}}」',
      openCopy: '打开',
    },
    /** 移动 / 复制对话框（ADR-0054 §C） */
    place: {
      moveTitle: '移动记录',
      copyTitle: '复制记录',
      moveHint: '换空间后可见范围按目标空间重新判定；目录下的子页留在原处并上移一级。',
      copyHint:
        '副本带正文、属性与你自己的标签，正文里的图片 / 文件另存一份；评论、版本历史与关联不带。',
      copyName: '副本标题',
      copyNameValue: '{{title}} 副本',
      after: '紧跟原记录之后',
      submitMove: '移动',
      submitCopy: '复制',
      moved: '已移动到「{{space}}」',
      copied: '已复制到「{{space}}」',
      same: '位置没有变化',
    },
    batch: {
      priority: '改优先级',
      select: '多选',
      done: '完成',
      selected: '已选 {{count}} 项',
      selectAll: '全选已加载',
      clear: '清空',
      moveTo: '移动到空间…',
      addTag: '加标签',
      removeTag: '去标签',
      archive: '归档',
      unarchive: '取消归档',
      delete: '删除',
      deleteTitle: '删除 {{count}} 篇记录？',
      deleteBody: '会移到回收站，可在回收站逐篇恢复。',
      result: '已处理 {{ok}} 项',
      partial: '已处理 {{ok}} 项，{{failed}} 项失败：{{reason}}',
      toggle: '选择「{{title}}」',
      bar: '批量操作',
      retype: '改类型',
      status: '改状态',
      noStatus: '所选记录的类型没有状态',
      count: '{{count}} 篇',
      pin: '固定',
    },
    list: {
      label: '列表',
      progress: '进度',
      noField: '这条记录没有该属性：不是用带它的模板新建的，或被所用模板移除了',
      resolvedAuto: '关闭（已修复 / 不修复）时自动记为当天，关闭后可改',
    },
    location: {
      label: '建在',
      space: '所在空间',
      where: '目录位置',
      root: '目录顶层',
      none: '不放进目录',
      under: '作为子页放在…之下',
      linkFrom: '关联到《{{title}}》 · {{kind}}',
      unlink: '不关联',
    },
    types: { manage: '管理类型' },
    tagsManage: '管理标签',
    tagFilter: '标签',
    tagFilterClear: '清除标签筛选',
    board: {
      label: '看板',
      empty: '暂无',
      moved: '已改为「{{status}}」',
      drag: '拖动「{{title}}」改状态',
    },
    timeline: {
      label: '时间线',
      undated: '未填日期',
      empty: '还没有带日期的记录',
    },
    kind: {
      decision: '决策',
      iteration: '迭代',
      bug: 'Bug',
      changelog: '变更',
      journal: '日志',
      note: '随笔',
      review: '复盘',
      optimize: '优化',
      plan: '学习计划',
      custom: '自定义',
    },
    visibility: { private: '仅自己', space: '空间可见', workspace: '全员可见' },
    untitled: '无标题',
    placeholder: '开始写作，输入 / 查看命令',
    reconnect: '重新连接',
    noAccess: '无权访问这篇记录',
    tooLarge: '文档过大，已切换为只读，请拆分内容',
    tooMany: '打开的标签页过多，请关闭其他标签页后重试',
    unknownBlock: '未识别的内容块（已保留原数据）',
    createNote: '新建随笔',
    props: {
      kind: '类型',
      visibility: '可见性',
      words: '字数',
      version: '版本号',
      showEmpty: '显示 {{n}} 个空属性',
      hideEmpty: '收起空属性',
      addTag: '添加',
    },
    new: '新记录',
    fieldsLabel: '元数据',
    newHint: '选择类型并填写标题，创建后进入编辑',
    title: '标题',
    titlePlaceholder: '给这篇记录起个标题',
    pinned: '已固定',
    pin: '固定',
    unpin: '取消固定',
    all: '全部记录',
    allKinds: '全部类型',
    mine: '只看我的',
    searchPlaceholder: '按标题筛选…',
    loadMore: '加载更多',
    sortLabel: '排序',
    changes: { label: '流转', empty: '还没有状态变化', count: '{{n}} 次' },
    views: {
      title: '我的视图',
      save: '保存视图',
      saved: '已保存视图',
      updated: '已用当前筛选覆盖',
      needFilter: '先选一些筛选条件',
      name: '视图名称',
      namePlaceholder: '如：P0 未关闭',
      nameHint: '给这组筛选起个名字，之后在左栏一点即用',
      menu: '视图「{{name}}」的更多操作',
      rename: '重命名',
      overwrite: '用当前筛选覆盖',
      delete: '删除视图',
      deleteTitle: '删除视图「{{name}}」？',
      deleteBody: '只删除这个筛选组合，不影响任何记录。',
    },
    group: {
      label: '分组',
      none: '不分组',
      by: '按{{field}}分组',
      empty: '未填写',
      partial: '已加载 {{loaded}} / 共 {{total}}',
    },
    templateField: '{{label}}（{{template}}）',
    sort: {
      '-updatedAt': '最近更新',
      '-createdAt': '最近创建',
      title: '按标题',
      priority: '按优先级',
      '-foundAt': '最近发现',
    },
    empty: {
      all: '还没有记录，先写下一点什么',
      decision: '还没有决定被记下来',
      iteration: '还没有迭代记录',
      bug: '还没有 Bug 记录，保持下去',
      changelog: '还没有变更记录',
      journal: '还没有日志',
      note: '还没有随笔',
      review: '还没有复盘',
    },
    field: {
      status: '状态',
      supersedesId: '取代的决策 ID',
      decidedAt: '决定日期',
      severity: '严重程度',
      commit: '提交',
      debugDir: '踩坑目录',
      periodStart: '开始日期',
      periodEnd: '结束日期',
      version: '版本',
      releasedAt: '发布日期',
      cycleId: '周期 ID',
      mood: '心情',
      metric: '衡量指标',
      target: '目标值',
      startDate: '开始日期',
      endDate: '结束日期',
      progress: '进度（%）',
      dueDate: '截止日',
      priority: '优先级',
      foundAt: '发现日期',
      resolvedAt: '解决日期',
      module: '模块',
    },
    mood: { 1: '很糟', 2: '低落', 3: '平静', 4: '不错', 5: '很好' },
    fieldValue: {
      proposed: '提议中',
      accepted: '已采纳',
      superseded: '已取代',
      rejected: '已否决',
      low: '低',
      medium: '中',
      high: '高',
      critical: '严重',
      new: '新建',
      pending: '待决策',
      fixed: '已修复',
      wontfix: '不修复',
      planned: '已排期',
      doing: '进行中',
      shipped: '已上线',
      dropped: '已放弃',
      planning: '规划中',
      active: '学习中',
      paused: '暂停',
      done: '已完成',
      p0: 'P0 紧急',
      p1: 'P1 高',
      p2: 'P2 中',
      p3: 'P3 低',
    },
    aside: {
      outline: '大纲',
      props: '属性',
      backlinks: '关联',
      comments: '评论',
      history: '历史',
      outlineEmpty: '还没有标题',
      moveSpace: '所在空间',
      markVersion: '标记版本',
      markVersionPlaceholder: '版本名，如「评审前」',
      marked: '已标记版本',
      moved: '已移动到 {{space}}',
      retyped: '已改为「{{kind}}」',
      updatedAt: '更新于',
      author: '作者',
      comingSoon: '将在后续版本提供',
      treePos: '目录位置',
      treeNone: '不在目录',
      treeRoot: '目录顶层',
      treeMoved: '已调整目录位置',
      leaveTreeTitle: '移动到其他空间？',
      leaveTreeBody:
        '这篇记录会移出当前空间的目录（子页一并移出），到新空间后可在「目录位置」重新放入。',
      leaveTreeOk: '移动',
    },
    history: {
      empty: '还没有历史版本：按 Ctrl / ⌘ + S 保存一个版本，编辑一段时间后也会自动留版',
      hint: 'Ctrl / ⌘ + S 保存版本（以「年月日-时分秒」命名）；另每 50 次保存或 30 分钟自动留一版。点开可预览、对比与恢复，标签按钮可打标记（带标记的永久保留）',
      tag: '打标记',
      tagPlaceholder: '如：发布前 / v1.0',
      tagSave: '保存',
      tagClear: '清除标记',
      auto: '自动保存 · v{{version}}',
      compare: '对比当前',
      restore: '恢复此版本',
      previewHint: '只读预览此版本的正文',
      diffSummary: '与当前相比：恢复后新增 {{added}} 段、移除 {{removed}} 段',
      legendAdd: '此版本有、当前没有',
      legendDel: '当前有、此版本没有',
      confirmTitle: '恢复到此版本？',
      confirmBody:
        '正文会改回此版本的内容，作为一次新的修改写入；恢复前的内容会自动存为一个版本，随时可以再恢复回来。正在协同的人会实时看到变化。',
      restored: '已恢复，正在同步到正文',
      restoreFailed: '恢复失败',
      loadFailed: '版本内容加载失败',
    },
  },
  bug: {
    stats: {
      label: '统计',
      total: '总数',
      open: '未关闭',
      p0Open: 'P0 未关闭',
      closedInRange: '区间内关闭',
      reopened: '重开次数',
      range: '统计区间',
      ranges: { '4w': '近 4 周', '12w': '近 12 周', '26w': '近 26 周', '12m': '近 12 个月' },
      trend: '趋势',
      trendHint: '存量按当前发现 / 解决日期倒推：重开、删除或归档会改变历史数字',
      created: '新增',
      resolved: '关闭',
      backlog: '未关闭存量',
      period: '起始日',
      asTable: '表格',
      asChart: '图表',
      bucketAria: '{{period}}：新增 {{created}}，关闭 {{resolved}}，未关闭 {{open}}',
      mttr: '修复时长（天）',
      mttrHint: '区间内已修复的 Bug：解决日期 − 发现日期',
      fixedCount: '已修复',
      avgDays: '平均',
      medianDays: '中位',
      aging: '未关闭账龄',
      agingHint: '今天 − 发现日期',
      agingBucket: { '0-7': '7 天内', '8-30': '8–30 天', '31-90': '31–90 天', '90+': '90 天以上' },
      filterBy: '只看「{{value}}」',
      empty: '暂无数据',
      loadFailed: '统计加载失败',
    },
  },
  link: {
    kind: {
      relates: '相关',
      blocks: '阻塞',
      caused_by: '起因于',
      resolves: '解决',
      mentions: '提及',
    },
    back: {
      relates: '相关',
      blocks: '被阻塞于',
      caused_by: '导致了',
      resolves: '被解决于',
      mentions: '在正文里提到',
    },
    kindLabel: '关联类型',
    createLinked: '新建并关联',
    fixedBugs: '本期修复的 Bug',
    fixedIn: '修复于',
    notFixedYet: '还没有关联到迭代或版本',
    addBug: '关联 Bug',
    markFixedIn: '标记修复于…',
    related: '关联',
    add: '添加关联',
    remove: '移除关联',
    backlinks: '反链',
    none: '暂无',
    noBacklinks: '还没有别的记录链接到这里',
  },
  kb: {
    tab: { home: '概览', tree: '目录' },
    edit: '编辑空间',
    defaultKind: '新建记录的默认类型',
    defaultTemplate: '新建记录的默认模板',
    defaultNone: '不设（随笔 / 按类型默认）',
    defaultHint: '在此空间新建记录时预选；只能选内置模板或工作区模板',
    description: '简介',
    kindHint: '类型决定概览页：项目 / 工作显示 Bug、迭代、版本与决策；学习显示学习计划与笔记',
    viewAll: '查看全部',
    view: '视图',
    viewCards: '卡片',
    viewTable: '表格',
    tags: '标签',
    home: {
      all: '全部',
      allStatuses: '全部',
      new: '新建{{kind}}',
      openInEntries: '在记录页打开',
      empty: '还没有{{kind}}，点右上角新建',
      emptyStatus: '这个状态下没有记录',
      more: '加载更多',
    },
    panel: {
      bugs: '未关闭的 Bug',
      iterations: '最近迭代',
      releases: '最新版本',
      decisions: '决策与优化',
      recent: '最近更新',
      plans: '学习计划',
      notes: '最近笔记',
    },
    empty: {
      bugs: '没有未关闭的 Bug',
      iterations: '还没有迭代记录',
      releases: '还没有发布记录',
      decisions: '还没有决策或优化',
      recent: '这个空间还是空的，从上面的快捷按钮开始记录吧',
      plans: '还没有学习计划',
      notes: '还没有笔记',
    },
    personal: {
      dir: '空间目录',
      manage: '管理空间',
      mine: '个人记录',
      recentAll: '各空间最近更新',
      emptyMine: '还没有个人记录，从上面的快捷按钮开始吧',
      emptyGroup: '这个大类下还没有空间',
      noSpaces: '还没有空间',
    },
    tree: {
      title: '目录',
      empty: '目录还是空的：新建一篇记录，或把已有记录拖进来',
      newChild: '新建子页',
      newRoot: '新建页面',
      moved: '已移动',
      moveFailed: '移动失败',
      dragHandle: '拖动「{{name}}」',
      unfiled: '其余记录',
      unfiledHint: '未放进目录的记录按更新时间列在这里，拖到上方即可归入目录',
      expandAll: '全部展开',
      collapseAll: '全部收起',
      filter: '筛选目录',
      breadcrumb: '所在目录',
      addToTree: '加入目录',
      indent: '缩进（成为上一项的子页）',
      outdent: '取消缩进（提升一级）',
      detach: '移出目录',
    },
  },
  reading: {
    title: '阅读与排版',
    pageTitle: '阅读与写作',
    pageHint:
      '字体、字号、行距、版心、纸张与目录格式；按账号保存，换设备也一样。只改你自己看到的样子，不影响正文内容和其他人。',
    preview: '预览',
    font: '字体',
    fonts: { sans: 'MiSans', wenkai: '文楷', song: '宋体', system: '系统', mono: '等宽' },
    fontsLong: {
      sans: 'MiSans · 默认',
      wenkai: '文楷 · 屏显',
      song: '宋体 · 系统',
      system: '系统无衬线',
      mono: '等宽 · JetBrains Mono',
    },
    capsule: {
      font: '正文字体',
      paper: '纸张样式',
      layout: '排版（字号 / 行距 / 段距 / 版心）',
      toc: '目录格式（章节编号 / 目录深度）',
    },
    size: '字号',
    sizes: { sm: '小', md: '标准', lg: '大', xl: '特大' },
    lineHeight: '行距',
    paragraph: '段距',
    spacing: { compact: '紧凑', standard: '标准', loose: '宽松' },
    width: '版心宽度',
    widths: { narrow: '窄', standard: '标准', wide: '宽', full: '满栏' },
    paper: '纸张',
    papers: {
      plain: '素纸',
      rice: '宣纸',
      grid: '方格',
      lines: '横线',
      dots: '点阵',
      kraft: '牛皮纸',
    },
    indent: '首行缩进两字',
    justify: '两端对齐',
    headingNumbers: '正文章节编号',
    tocNumbers: '目录自动编号',
    tocNumbersHint: '右侧目录与目录块显示 1 / 1.1 编号',
    headingNumbersHint: '正文、大纲与目录块显示 1 / 1.1 编号，不写进正文',
    tocDepth: '目录深度',
    tocDepthN: '{{n}} 级',
    codeFold: '代码块',
    codeFolds: { expanded: '默认展开', collapsed: '默认折叠', auto: '长代码折叠' },
    reset: '恢复默认',
    saveFailed: '阅读偏好保存失败，已在本机生效',
    focus: '专注写作',
    focusExit: '退出专注',
    focusExitHint: '退出专注（Esc）',
    sample: {
      h1: '晨间笔记',
      p1: '燕子衔枝筑巢，一枝一叶都是日积月累。把今天读到的、想到的记下来，明天的自己会感谢现在的你。',
      h2: '要点',
      p2: '好的排版让人读得更久：行距舒展、版心适中、段落之间留出呼吸。',
      h3: '下一步',
      p3: '挑一种顺眼的字体与纸张，然后开始写。',
    },
  },
  template: {
    title: '模板',
    pick: '模板',
    byKind: '按类型默认',
    byKindHint: '用所选类型的默认骨架',
    recommended: '推荐',
    source: {
      dev: '开发',
      learning: '学习',
      builtin: '内置',
      personal: '我的',
      workspace: '工作区',
    },
    manageHint:
      '内置模板覆盖开发与学习场景；可以在这里新建，也可以在任意记录的「属性」里「另存为模板」。我的模板只有你能用；共享到工作区后，同工作区的成员都能使用和复制。',
    empty: '还没有自定义模板',
    newTemplate: '新建模板',
    newTitle: '新建模板',
    editTitle: '编辑模板',
    backToList: '返回模板列表',
    edit: '编辑',
    save: '保存',
    savedTemplate: '已保存模板',
    created: '已创建模板「{{name}}」',
    notFound: '模板不存在或你没有权限查看',
    readOnly: '这个模板由他人共享，你只能查看；「复制到我的」后可以修改。',
    name: '名称',
    description: '描述',
    descriptionPlaceholder: '一句话说明适合什么场景（可选）',
    kind: '记录类型',
    spaceKind: '适用空间',
    spaceKindAny: '不限',
    share: '共享给工作区成员',
    shareHint: '同工作区的成员都能看到、使用和复制；只有你和管理员能修改',
    sharedBy: '由 {{name}} 共享',
    deletedUser: '已删除的用户',
    shared: '已共享到工作区',
    unshared: '已取消共享',
    unshare: '取消共享',
    unshareConfirm: '取消共享「{{name}}」？其他成员将看不到它，已用它创建的记录不受影响。',
    defaultsWarning: '有 {{count}} 个空间把它设为默认模板，操作后这些空间的默认模板会被清空。',
    copyToMine: '复制到我的',
    copyName: '{{name}} 副本',
    copied: '已复制为「{{name}}」',
    copyLink: '复制链接',
    linkCopied: '链接已复制，同工作区成员登录后可打开',
    stale: '模板已被他人修改，已刷新为最新内容',
    editor: {
      body: '模板正文',
      placeholder: '输入 / 插入标题、表格、提示块…',
      varsHint: '可用占位符，新建记录时自动替换：',
      noAttachments: '模板不能带附件，请在用模板建好的记录里上传',
    },
    useIt: '用此模板新建',
    preview: '预览',
    rename: '重命名',
    delete: '删除模板',
    deleteConfirm: '删除模板「{{name}}」？已用它创建的记录正文不受影响。',
    fieldsLossWarning:
      '有 {{count}} 条记录是用它创建的，这些记录里模板属性（{{fields}}）的值会被清空。',
    resetConfirm: '把「{{name}}」恢复为默认内容？',
    metaSummary: '模板属性：{{fields}}',
    metaRemoved: '已移除：{{fields}}',
    deleteBuiltinConfirm:
      '删除内置模板「{{name}}」？全员的新建列表里都不再出现，已用它创建的记录不受影响；可在「已删除的内置模板」里恢复。',
    resetDefault: '恢复默认',
    resetDone: '已恢复为默认内容',
    customized: '已修改（所有者维护）',
    deletedBuiltins: '已删除的内置模板',
    restore: '恢复',
    restored: '已恢复「{{name}}」',
    scopeBuiltin: '设为内置模板（全员可见，仅所有者可修改）',
    scopeBuiltinHint: '内置模板对所有成员可见、可用，只有工作区所有者能修改或删除',
    deleted: '已删除模板',
    saved: '已存为模板「{{name}}」',
    saveAs: '另存为模板',
    saveAsName: '模板名称',
    insert: '插入模板',
    insertHint: '在光标处插入所选模板的正文，不替换已有内容',
    groups: { builtin: '内置模板', personal: '我的模板', workspace: '工作区共享' },
    kindLabel: '类型：{{kind}}',
    noFields: '该类型没有属性',
    meta: {
      title: '元数据',
      hint: '用此模板新建的记录带这些属性。类型属性来自所选类型；模板属性只属于这个模板，可以随时增、删、改。',
      typeFields: '类型属性 · {{type}}',
      ownFields: '模板属性',
      ownEmpty: '还没有模板属性',
      add: '添加属性',
      preset: '预填',
      remove: '从本模板移除「{{name}}」',
      restore: '恢复「{{name}}」',
      removed: '已移除 {{count}} 个：',
      locked: '类型必需的属性，不能移除',
      lossBody:
        '有 {{count}} 条记录是用这个模板创建的。保存后，这些记录里以下属性 / 选项的值会被清空：{{items}}。',
      previewTitle: '属性',
    },
    editTypeFields: '编辑「{{type}}」类型本身的字段',
    editTypeFieldsHint: '改的是类型本身：会影响该类型的全部记录与模板。',
    personalTypeShared: '个人类型只能用于个人模板，共享给工作区前请换成内置或空间类型',
  },
  editor: {
    mermaid: {
      label: 'Mermaid 图表',
      edit: '编辑图表',
      done: '完成',
      empty: '点击编写 Mermaid 图表',
      emptyReadOnly: '（空图表）',
      rendering: '渲染中…',
      error: '图表语法有误',
      sourceLabel: 'Mermaid 源码',
      sourceHint: '例如：graph TD; A-->B（Esc 或 ⌘↵ 完成）',
    },
    math: {
      edit: '编辑公式',
      empty: '点击编写公式',
      inlineEmpty: '公式',
      sourceLabel: 'LaTeX 公式',
      sourceHint: '例如：E = mc^2（Esc 或 ⌘↵ 完成）',
    },
    query: {
      untitled: '查询视图',
      view: '显示为',
      views: { table: '表格', stats: '统计', count: '计数' },
      open: '在记录页打开',
      settings: '设置查询',
      settingsHint: '结果按阅读者自己的权限实时查询，不会写进正文',
      titleLabel: '标题',
      allSpaces: '全部空间',
      limit: '最多显示条数',
      countUnit: '条记录',
      empty: '没有符合条件的记录',
      more: '显示前 {{shown}} 条，共 {{total}} 条',
      staticHint: '查询视图 · 打开记录页查看实时结果',
    },
    slash: {
      empty: '没有匹配的命令',
      groups: {
        basic: '基础',
        list: '列表',
        code: '代码',
        structure: '结构',
        media: '媒体',
        template: '模板',
        diagram: '图表',
        time: '时间',
      },
      h1: '标题 1',
      h2: '标题 2',
      h3: '标题 3',
      h4: '标题 4',
      paragraph: '正文',
      quote: '引用',
      hr: '分割线',
      bullet: '无序列表',
      ordered: '有序列表',
      todo: '任务列表',
      code: '代码块',
      mermaid: 'Mermaid 图表',
      math: '公式块',
      table: '表格',
      details: '折叠',
      info: '提示',
      tip: '技巧',
      warn: '警告',
      danger: '危险',
      toc: '目录',
      image: '图片',
      file: '附件',
      template: '插入模板',
      card: '记录卡片',
      linkCard: '网页卡片',
      entryLink: '记录链接',
      query: '查询视图',
      source: 'Markdown 源码',
      link: '链接',
      date: '今天日期',
      time: '当前时间',
      datetime: '日期时间',
      mathInline: '行内公式',
      mermaidFlow: '流程图',
      mermaidSeq: '时序图',
      mermaidClass: '类图',
      mermaidState: '状态图',
      mermaidGantt: '甘特图',
      terms: {
        link: '链接 超链接 网址',
        linkCard: '网页 卡片 书签 网址 链接预览',
        date: '日期 今天 时间',
        time: '时间 现在',
        datetime: '日期时间 时间 现在',
        mathInline: '行内公式 公式',
        mermaidFlow: '流程图 图表',
        mermaidSeq: '时序图 图表',
        mermaidClass: '类图 图表',
        mermaidState: '状态图 图表',
        mermaidGantt: '甘特图 图表',
        source: '源码 markdown',
        h1: '标题1 标题',
        h2: '标题2 标题',
        h3: '标题3 标题',
        h4: '标题4 标题',
        paragraph: '正文 文本',
        quote: '引用',
        hr: '分割 分割线',
        bullet: '列表 无序',
        ordered: '编号 有序',
        todo: '待办 任务',
        code: '代码',
        mermaid: '图表 流程图',
        math: '公式 数学',
        table: '表格',
        details: '折叠',
        info: '提示',
        tip: '技巧',
        warn: '警告',
        danger: '危险',
        toc: '目录',
        image: '图片',
        file: '附件 文件',
        card: '卡片',
        entryLink: '链接 双链',
        template: '模板',
      },
    },
    docbar: {
      lastSaved: '上次保存',
      reading: '阅读设置',
      readingShort: '阅读',
      focus: '专注',
      markdown: 'Markdown',
      document: '文档操作',
    },
    version: {
      save: '保存版本',
      saveShort: '保存',
      saved: '已保存版本 {{name}}',
      unchanged: '没有新改动，未生成版本（标题与属性不在版本里）',
      throttled: '刚刚保存过，请稍后再试',
      readonly: '只读，不能保存版本',
      offline: '尚未连上服务器，联网同步后再保存版本',
      timeout: '保存版本超时，请重试',
      failed: '保存版本失败',
    },
    toolbar: {
      label: '编辑工具栏',
      insert: '插入内容块',
      insertSearch: '搜索要插入的内容',
      sections: {
        basic: '基础',
        text: '文本',
        list: '列表',
        layout: '布局',
        dev: '公式',
        diagram: '图表',
        relate: '关联',
        time: '时间',
      },
      tableSize: '选择表格大小',
      undo: '撤销',
      redo: '重做',
      clear: '清除格式',
      block: '段落格式',
      headingN: '标题 {{level}}',
      bold: '加粗',
      italic: '斜体',
      underline: '下划线',
      strike: '删除线',
      moreMarks: '更多样式（行内代码 / 上标 / 下标）',
      code: '行内代码',
      sup: '上标',
      sub: '下标',
      textColor: '文字颜色',
      bgColor: '背景颜色',
      colorDefault: '默认颜色',
      bgNone: '无背景',
      align: '对齐',
      align_left: '左对齐',
      align_center: '居中',
      align_right: '右对齐',
      link: '链接',
      linkUrl: '链接地址',
      linkText: '显示文字（可选）',
      linkApply: '确定',
      unlink: '移除链接',
      words: '{{n}} 字',
      overflow: '更多格式',
    },
    bubble: {
      bold: '加粗',
      italic: '斜体',
      strike: '删除线',
      code: '行内代码',
      link: '链接',
      highlight: '背景颜色',
      textColor: '文字颜色',
      colorDefault: '默认颜色',
      bgNone: '无背景',
      underline: '下划线',
      linkPrompt: '链接地址（http / https / mailto）',
      linkInvalid: '只支持 http / https / mailto 链接',
      unlink: '移除链接',
      comment: '评论',
    },
    /** 网页卡片 / 链接气泡 / 悬停预览（ADR-0054 §D） */
    linkCard: {
      loading: '正在获取网页信息…',
      failed: '无法获取网页信息',
      invalid: '请输入 http / https 网址',
      placeholder: '粘贴或输入网页地址，回车确定',
      asLink: '链接',
      asTitle: '标题',
      asCard: '卡片',
      refresh: '刷新',
      open: '打开',
      copy: '复制链接',
      copied: '已复制链接',
      edit: '编辑',
      unlink: '移除',
      showAs: '显示为',
      text: '显示文字',
      href: '链接地址',
      editTitle: '编辑网页卡片',
      textAuto: '留空则用网页标题',
      fetchingTitle: '取标题…',
    },
    language: '语言',
    plainText: '纯文本',
    uploading: '上传中…',
    uploadFailed: '上传失败：{{name}}',
    imagesOnly: '这里只能插入图片：{{name}}',
    tooLargeSoft: '文档过大（超过 10 MB），建议拆分；已暂停插入附件',
    imageLimit: '单篇最多 200 张图片',
    externalImageDropped: '外部图片未导入：请下载后再粘贴或拖入',
    pasteTruncated: '粘贴内容超过 2 MB，已截断',
    source: {
      open: 'Markdown',
      title: '以 Markdown 编辑源码',
      hint: '保存时一次性导入正文：未改动的段落原样保留；附件、记录卡片等以 ⟦xz-keep⟧ 占位行表示，删掉该行即删除该块。保存前会自动存一个版本。',
      placeholder: '在这里写 Markdown…',
      apply: '保存到正文',
      saved: '已按 Markdown 更新正文',
      failed: '保存失败，正文未改动',
      busy: '有其他人正在编辑，暂不能用源码模式',
      snapshotLabel: '源码编辑前',
      lossy:
        '这篇正文含 Markdown 无法表达的格式（{{list}}）：只要不改动所在段落就会保留，改动后该段的这些格式会丢失。',
      lossyKind: {
        underline: '下划线',
        highlight: '高亮',
        textColor: '文字颜色',
        subscript: '下标',
        superscript: '上标',
        comment: '评论标注',
        mention: '@提及',
        mathInline: '行内公式',
        textAlign: '对齐方式',
      },
    },
    mdFile: {
      title: '插入 Markdown 文件',
      body: '「{{names}}」可以把内容转成正文插入，也可以作为附件保留原文件。',
      insert: '插入内容',
      attach: '作为附件',
    },
    preview: '预览',
    attachmentPreview: '附件内容预览',
    previewFailed: '无法预览，请下载后查看',
    previewTruncated: '文件较大，只显示前 1 MB',
    image: {
      caption: '图注',
      captionPlaceholder: '添加图注…',
      align: { left: '靠左', center: '居中', right: '靠右' },
    },
    pastedMarkdown: '已识别为 Markdown 并转换',
    pasteAsPlain: '撤销为纯文本',
    unknownBlock: '未识别的内容块（已保留原数据）',
    tocEmpty: '添加标题后这里会出现目录',
    toc: { title: '目录', count: '{{n}} 个标题' },
    attachment: '附件',
    download: '下载',
    card: '记录卡片',
    dragHandle: '拖动以移动此块',
    // ADR-0025 §3–§6（Fork B）：表格工具条 / 块手柄菜单 / 提示块 / 代码块头部
    table: {
      toolbar: '表格工具',
      rowBefore: '上方插入行',
      rowAfter: '下方插入行',
      colBefore: '左侧插入列',
      colAfter: '右侧插入列',
      deleteRow: '删除行',
      deleteCol: '删除列',
      merge: '合并单元格',
      split: '拆分单元格',
      headerRow: '表头行',
      headerCol: '表头列',
      deleteTable: '删除表格',
    },
    block: {
      handleHint: '拖动移动；点击打开菜单',
      convert: '转换为',
      wrap: '包裹为',
      actions: '操作',
      paragraph: '正文',
      heading: '标题 {{level}}',
      bullet: '无序列表',
      ordered: '有序列表',
      todo: '任务列表',
      quote: '引用',
      code: '代码块',
      details: '折叠块',
      duplicate: '复制此块',
      delete: '删除此块',
    },
    callout: {
      switch: '切换提示块类型',
      unwrap: '取消提示块',
      kind: { info: '提示', tip: '技巧', warn: '注意', danger: '危险' },
    },
    code: {
      copy: '复制',
      copied: '已复制',
      copyFailed: '复制失败，请手动选择复制',
      lines: '{{n}} 行',
      collapse: '折叠代码块',
      expand: '展开代码块',
      expandN: '展开全部 {{n}} 行',
    },
    mobile: {
      toolbar: '编辑工具条',
      undo: '撤销',
      redo: '重做',
      bold: '加粗',
      italic: '斜体',
      heading: '标题',
      bullet: '列表',
      todo: '任务项',
      quote: '引用',
      code: '代码块',
      link: '链接',
      image: '图片',
      slash: '更多命令',
      hide: '收起键盘',
    },
    pickEntry: '选择记录',
    pickEntryPlaceholder: '按标题搜索记录…',
    pickCreate: '新建《{{title}}》并插入',
    offlineStorage: '离线保存不可用：浏览器禁止了本地存储，编辑仍会实时同步',
  },
  notif: {
    bell: '通知',
    unread: '{{count}} 条未读',
    empty: '没有新通知',
    markAllRead: '全部已读',
    viewAll: '查看全部',
    archive: '归档',
    quiet: '一切安静',
    loadError: '通知加载失败',
    tab: { all: '全部', mentions: '提及', unread: '未读' },
    kind: {
      'entry.updated': '记录更新',
      'task.assigned': '任务指派给我',
      'task.unassigned': '任务被取消指派',
      'task.due_soon': '任务即将到期',
      'task.completed': '任务完成',
      'task.uncompleted': '撤销完成',
      'task.commented': '任务评论',
      'entry.commented': '记录评论',
      'mention.created': '提及我',
      'space.invited': '加入空间',
      'member.joined': '新成员加入',
      'member.requested': '注册申请待审批',
      'workspace.owner_transferred': '所有者转移',
      'cycle.review_due': '周期复盘提醒',
      'calendar.reminder': '日程提醒',
      'system.export_done': '导出完成',
      'system.backup_failed': '备份失败',
      'system.outbox_stalled': '通知积压告警',
    },
    prefs: {
      title: '通知偏好',
      kind: '事件',
      digest: '频率',
      instant: '即时',
      daily: '每日摘要',
      default: '默认',
      channel: { site: '站内', email: '邮件', webpush: '桌面推送（二期）' },
    },
  },
  cmd: {
    palette: '命令面板',
    placeholder: '输入命令或搜索任务 / 记录…',
    empty: '没有匹配的命令',
    searching: '搜索中…',
    results: '搜索结果',
    later: '后续版本',
    help: '快捷键',
    helpHint: '全局快捷键与列表内按键',
    go: '前往{{page}}',
    goSpace: '前往空间：{{name}}',
    densityCompact: '切换为紧凑密度',
    densityComfortable: '切换为舒适密度',
    readingSettings: '阅读与写作设置（字体 / 排版 / 纸张）',
    focus: '进入专注写作',
    focusExit: '退出专注写作',
    copyTitle: '复制标题',
    titleCopied: '已复制标题「{{title}}」',
    dueToday: '今天',
    dueTomorrow: '明天',
    dueNextWeek: '下周一',
    dueClear: '清除截止',
    group: { context: '当前对象', navigate: '跳转', create: '创建', prefs: '界面' },
    page: { status: '改状态', assignee: '指派给', due: '设截止', space: '移动到空间' },
    task: {
      status: '改状态…',
      assign: '指派…',
      due: '设截止…',
      cycle: '移到周期…',
      open: '打开详情',
      peek: '预览',
    },
    entry: { mark: '标记版本', export: '导出 Markdown', move: '移动到空间…' },
    space: { newTask: '在此空间新建任务', entries: '查看空间记录', invite: '邀请成员' },
    keys: {
      move: '列表上下移动',
      complete: '完成 / 取消完成',
      select: '多选',
      extend: '扩选（向下 / 向上）',
      rename: '改名',
      menu: '任务菜单',
      open: '打开',
      peek: '预览',
      slash: '编辑器命令',
      copyTitle: '复制当前任务 / 记录标题',
    },
  },
  peek: {
    title: '预览',
    open: '打开详情',
    hint: '回车打开 · Esc 关闭',
    parent: '父任务',
    estimate: '预估',
    minutes: '{{n}} 分钟',
    noDescription: '没有描述',
    noBody: '还没有正文',
    created: '创建于',
    updated: '更新于',
    completed: '完成于',
  },
  search: {
    all: '全部',
    hint: '输入关键词搜索任务与记录',
    empty: '没有找到，试试更短的词',
    recent: '最近访问',
    limited: '搜索太频繁，请稍后再试',
  },
  trash: {
    tab: { tasks: '任务', entries: '记录', spaces: '空间' },
    hint: '删除的内容保留 {{days}} 天，之后自动清除',
    empty: '回收站是空的',
    restore: '恢复',
    restored: '已恢复',
    purge: '永久删除',
    purged: '已永久删除',
    purgeTitle: '永久删除？',
    purgeHint: '「{{name}}」将被彻底删除，无法恢复。',
    forbidden: '只有所有者或管理员可以永久删除',
    daysLeft: '剩 {{count}} 天',
    selectAll: '全选',
    select: '选择「{{name}}」',
    selected: '已选 {{count}} 个',
    restoreSelected: '恢复所选',
    purgeSelected: '永久删除所选',
    purgeManyTitle: '永久删除 {{count}} 个空间？',
    purgeManyHint:
      '其中共有 {{entries}} 条记录、{{tasks}} 个任务，连同评论与附件将被彻底删除，无法恢复。',
    batchResult: '已处理 {{ok}} 个',
    batchPartial: '成功 {{ok}} 个，{{failed}} 个未处理：{{reason}}',
  },
  comment: {
    title: '评论',
    placeholder: '写评论，回车发送，Shift+回车换行，@ 提及',
    reply: '回复…',
    empty: '还没有评论',
    failed: '评论没有发出去，请重试',
    deleted: '此评论已删除',
    orphaned: '原文已删除，讨论保留',
    resolve: '解决',
    unresolve: '重新打开',
    resolvedCount: '已解决 {{count}} 条',
    noMember: '没有匹配的成员',
  },
  design: {
    title: '设计画廊',
    tabs: { tokens: 'Token', materials: '材质', depth: '深度', switch: '切换', components: '组件' },
    color: '色板',
    typography: '字体',
    spacing: '间距',
    motion: '动效',
    contrast: '对比度',
    surfaceBackdrop: '纯底板',
    surfaceImage: '带图片',
    surfaceText: '带密集文字',
    denseText: '燕子衔枝筑巢，一点一点，把零散的日子搭成自己的东西。',
    dragMe: '拖动我',
    states: { rest: '静止', hover: '悬停', drag: '拖拽' },
    circleReveal: '圆形揭幕',
    dissolve: '整页溶解',
    simulateReducedMotion: '模拟减弱动效',
    simulateReducedTransparency: '模拟降低透明度',
    variants: '变体',
    sample: '示例文字',
    dialogTitle: '对话框',
    dialogBody: '玻璃浮层 portal 到 body，带折射环与左上高光。',
    sheetTitle: '侧边面板',
    popover: '弹出层内容',
    tooltip: '提示',
    toastDone: '任务已完成',
    toastError: '保存失败',
    commandPlaceholder: '输入命令',
    commandEmpty: '没有匹配的命令',
    tab1: '第一页',
    tab2: '第二页',
    checkbox: '复选框',
    inputPlaceholder: '输入框',
    intro:
      '对照全站 token、玻璃材质与组件的内部页面，也是截图回归的基准。改过 tokens.css 或组件样式后，切到「并排」把每页过一遍。',
    hint: {
      tokens: '颜色、对比度、字体、间距与动效时长；对比度按当前主题实时计算。',
      materials: '四级玻璃叠在纯底、图片、密集文字上：看文字是否始终可读。',
      depth: '三级阴影与棱线；拖动卡片看静止 → 悬停 → 拖拽三态。',
      switch: '日场 / 夜场切换动画；可模拟系统的减弱动效与降低透明度。',
      components: '按钮、表单、浮层与领域组件（类型色块、色板、燕印、目录树）的各种状态。',
    },
    baseline: '确认新视觉后更新截图基线：',
    toolbar: {
      theme: '主题',
      motion: '动效档位',
      themeOpt: { current: '当前', light: '日场', dark: '夜场', both: '并排' },
      glass: '玻璃强度',
      glassOpt: { standard: '标准', clear: '清透', vivid: '晶亮', liquid: '流光' },
      glassHint: '与「设置 → 个人 → 玻璃强度」同一偏好，随账号保存',
    },
    contrastHint: '纯底上的实测值；玻璃「最坏合成底」以 pnpm lint 的 check-contrast 为准。',
    onBg: '底板',
    onPaper: '纸面',
    pass: '达标',
    fail: '未达标',
    domain: '领域组件',
    kindChips: '类型色块 · xs / sm / md / lg',
    kindBadges: '类型胶囊',
    paletteChips: '9 色板色块',
    seal: '燕印 · sm / md / lg',
    tree: '目录引导线与字重分级',
    treeNodes: { a: '产品规划', b: '迭代 v1.2', c: '登录页 Bug', d: '发布说明', e: '周记' },
  },
  errors: {
    INTERNAL: '服务器出错了，请稍后重试',
    UNAUTHENTICATED: '请先登录',
    FORBIDDEN: '没有权限',
    NOT_FOUND: '内容不存在',
    VALIDATION: '请检查输入',
    RATE_LIMITED: '操作过于频繁',
    NETWORK: '网络连接失败',
    CONFLICT_IN_FLIGHT: '上一次提交还在处理中，请稍候',
  },
} as const
